const tabs = document.querySelectorAll(".tab");
const contents = document.querySelectorAll(".tab-content");

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    tabs.forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");

    const selected = tab.getAttribute("data-tab");
    contents.forEach((c) => {
      c.style.display = c.id === selected ? "flex" : "none";
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('scanForm');
  const input = document.getElementById('scan_ada_input');
  
  if (!form || !input) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if (!input.value.trim()) {
      input.classList.add('is-invalid');
    } else {
      input.classList.remove('is-invalid');
      alert("Scan started for: " + input.value);
    }
  });
});




jQuery(document).ready(function () { 

  // Scan Bar Footer
  const scan_submit_button_2 = document.getElementById("scan_ada_btn");
  if (scan_submit_button_2) {
    const scan_submit_input = document.getElementById("scan_ada_input");
    const error_message = document.getElementById("scan-form-error-2");
    const httpRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/;
    scan_submit_button_2.addEventListener("click", (e) => {
      e.preventDefault();
      const inputValue = scan_submit_input.value;
      requestAnimationFrame(() => {
        if (inputValue === "") {
          error_message.textContent = "Please enter website URL";
          error_message.style.display = "block";
        } else if (!httpRegex.test(inputValue)) {
          error_message.textContent = "Please enter a valid website URL";
          error_message.style.display = "block";
        } else {
          error_message.style.display = "none";
          // Optional: prevent multiple submissions
          scan_submit_button_2.disabled = true;
          // Delay redirect slightly to ensure DOM updates are flushed
          setTimeout(() => {
            window.location.href = `https://freeaccessibilitychecker.skynettechnologies.com/?website=${inputValue}`;
          }, 50);
        }
      });
    });
  }
});

// Lazy load bg images
function onScreenCheck($elem) {
  const elemTop = $elem[0].getBoundingClientRect().top;
  const windowHeight = window.innerHeight;

  if (elemTop < windowHeight) {
    $elem.addClass("on-screen");
  }
}
let ticking = false;
jQuery(window).on("scroll", function () {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const elements = [
        ".globalStandards-sec",
      ];
      elements.forEach(selector => {
        const $el = jQuery(selector);
        if ($el.length) {
          onScreenCheck($el);
        }
      });
      ticking = false;
    });
    ticking = true;
  }
});



// Back to top
var amountScrolled = 200;
var amountScrolledNav = 25;
$(window).scroll(function() {
  if ( $(window).scrollTop() > amountScrolled ) {
    $('button.back-to-top').addClass('show');
  } else {
    $('button.back-to-top').removeClass('show');
  }
});

$('button.back-to-top').click(function() {
  $('html, body').animate({
    scrollTop: 0
  }, 200);
  return false;
});


  // FAQ script
$(document).ready(function () {
  const openId = localStorage.getItem("openFaqId");
  if (openId) {
    const $item = $(`.faq-item[data-id="${openId}"]`);
    $item.addClass("active");
    $item.find(".faq-answer").slideDown();
  }

  $(".faq-question").on("click", function () {
    const $item = $(this).closest(".faq-item");

    // Collapse all others
    $(".faq-item").not($item).removeClass("active").find(".faq-answer").slideUp();

    // Toggle this one
    const isActive = $item.hasClass("active");
    $item.toggleClass("active");
    $item.find(".faq-answer").slideToggle();

    // Save or remove from localStorage
    if (!isActive) {
      localStorage.setItem("openFaqId", $item.data("id"));

      // Scroll only if element is not fully in view
      const itemTop = $item.offset().top;
      const itemBottom = itemTop + $item.outerHeight();
      const viewTop = $(window).scrollTop();
      const viewBottom = viewTop + $(window).height();

      const isFullyVisible = itemTop >= viewTop && itemBottom <= viewBottom;

      if (!isFullyVisible) {
        $('html, body').animate({
          scrollTop: itemTop - 20
        }, 500);
      }

    } else {
      localStorage.removeItem("openFaqId");
    }
  });
});


// swiper slider
// import Swiper from 'swiper';
// import { Navigation, Autoplay } from 'swiper/modules';

// const swiper = new Swiper('.mySwiper', {
//   modules: [Autoplay, Navigation], // required in newer versions
//   loop: true,
//   autoplay: {
//     delay: 4000,
//     disableOnInteraction: false,
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   slidesPerView: 3.5,
//   spaceBetween: 20,
//   breakpoints: {
//     0: { slidesPerView: 1 },
//     768: { slidesPerView: 3 },
//     1200: { slidesPerView: 2 },
//     1300: { slidesPerView: 2.5 },
//     1600: { slidesPerView: 3.5 }
//   },
//   on: {
//     init: function () {
//       updateProgressBar(this);
//     },
//     slideChange: function () {
//       updateProgressBar(this);
//     }
//   }
// });

// function updateProgressBar(swiperInstance) {
//   const totalSlides = swiperInstance.slides.length - swiperInstance.loopedSlides * 2;
//   const currentSlide = swiperInstance.realIndex + 1;
//   const progressPercent = (currentSlide / totalSlides) * 74.7;
//   document.querySelector('.swiper-progress-fill').style.width = progressPercent + '%';
// }
// // Add these lines to pause on hover and resume on mouse leave
// const swiperContainer = document.querySelector('.mySwiper');

// swiperContainer.addEventListener('mouseenter', function () {
//   swiper.autoplay.stop();
// });

// swiperContainer.addEventListener('mouseleave', function () {
//   swiper.autoplay.start();
// });